export interface SidebarVisibilityThreadShape {
  readonly archivedAt?: string | null;
}

/**
 * A sidebar thread is visible when it has not been archived.
 * Undefined archivedAt is treated as visible (older snapshots may omit the field).
 */
export function isSidebarThreadVisible(thread: SidebarVisibilityThreadShape): boolean {
  return thread.archivedAt == null;
}
